import React from "react";

const NeueTableStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 17H15.069C15.5811 17 16.0723 16.7966 16.4344 16.4344C16.7966 16.0723 17 15.5811 17 15.069V10M10 17H4.93103C4.41889 17 3.92773 16.7966 3.56559 16.4344C3.20345 16.0723 3 15.5811 3 15.069V10M10 17V3M17 10V4.93103C17 4.41889 16.7966 3.92773 16.4344 3.56559C16.0723 3.20345 15.5811 3 15.069 3H10M17 10H3M3 10V4.93103C3 4.41889 3.20345 3.92773 3.56559 3.56559C3.92773 3.20345 4.41889 3 4.93103 3H10",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NeueTableStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;